import OtherPhysicianEditDialog from './OtherPhysicianEditDialog.view';

export default OtherPhysicianEditDialog;
